import {
  emitFacebookTrack,
  emitGoogleTrack,
  emitLinkedinTrack,
} from "@helpers/siteTracking/emitters";

export const accountVerification = ({
                                      currency,
                                      email,
                                    }: {
  currency: string;
  email: string;
}) => {
  emitGoogleTrack({
    event: "new_registration",
    value: 0,
    currency,
    email,
  });
  emitFacebookTrack("CompleteRegistration");
  emitLinkedinTrack("1441049");
};

export const trialVerification = ({
                                    currency,
                                    email,
                                  }: {
  currency: string;
  email: string;
}) => {
  emitGoogleTrack({
    event: "free_trial",
    value: 0,
    currency,
    email,
  });
  emitFacebookTrack("StartTrial");
  emitLinkedinTrack("1441041");
};

export const successfulTrialUpgrade = ({
                                         orderId,
                                         value,
                                         currency,
                                         email,
                                         newCustomer,
                                       }: {
  orderId?: any;
  value?: number;
  currency?: string;
  email: string;
  newCustomer: boolean;
}) => {
  emitGoogleTrack({
    orderId: orderId || "", // Insert the order ID, if applicable
    orderValue: value || 0,
    event: "trial_upgrade",
    email,
    new_customer: newCustomer,
  });
  emitFacebookTrack("TrialToPackageUpgrade", {
    value: value || 0,
    order_id: orderId,
    currency,
  });
  emitLinkedinTrack("1595937");
};

export const successfulPlanPurchase = ({
                                         orderId,
                                         value,
                                         email,
                                         newCustomer,
                                       }: {
  orderId?: any;
  value?: number;
  email: string;
  newCustomer: boolean;
}) => {
  emitGoogleTrack({
    orderId: orderId || "", // Insert the order ID, if applicable
    orderValue: value || 0,
    event: "voip_business",
    email,
    new_customer: newCustomer,
  });
};

export const corePurchase = ({
                               orderId,
                               value,
                               currency,
                               email,
                               newCustomer,
                             }: {
  orderId?: any;
  value?: number;
  currency?: string;
  email: string;
  newCustomer: boolean;
}) => {
  emitGoogleTrack({
    orderId: orderId || "", // Insert the order ID, if applicable
    orderValue: value || 0,
    event: "voip_starting_out",
    email,
    new_customer: newCustomer,
  });
  emitFacebookTrack("VoIPStartingOut", {
    value: value || 0,
    order_id: orderId,
    currency,
  });
  emitLinkedinTrack("1418609");
};

export const coreUserPurchase = ({
                                   orderId,
                                   value,
                                   quantity,
                                   currency,
                                   email,
                                   newCustomer,
                                 }: {
  orderId?: any;
  value?: number;
  quantity?: number;
  currency?: string;
  email: string;
  newCustomer: boolean;
}) => {
  emitGoogleTrack({
    orderId: orderId || "", // Insert the order ID, if applicable
    orderValue: value || 0,
    event: "user_purchase_starting_out",
    email,
    new_customer: newCustomer,
  });
  emitFacebookTrack("VoIPStartingOut", {
    value: value || 0,
    quantity: quantity || 0,
    order_id: orderId,
    currency,
  });
};

export const standardPurchase = ({
                                   orderId,
                                   value,
                                   currency,
                                   email,
                                   newCustomer,
                                 }: {
  orderId?: any;
  value?: number;
  currency?: string;
  email: string;
  newCustomer: boolean;
}) => {
  emitGoogleTrack({
    orderId: orderId || "", // Insert the order ID, if applicable
    orderValue: value || 0,
    event: "voip_flying_high",
    email,
    new_customer: newCustomer,
  });
  emitFacebookTrack("VoIPFlyingHigh", {
    value: value || 0,
    order_id: orderId,
    currency,
  });
  emitLinkedinTrack("1441025");
};

export const standardUserPurchase = ({
                                       orderId,
                                       value,
                                       quantity,
                                       currency,
                                       email,
                                       newCustomer,
                                     }: {
  orderId?: any;
  value?: number;
  quantity?: number;
  currency?: string;
  email: string;
  newCustomer: boolean;
}) => {
  emitGoogleTrack({
    orderId: orderId || "", // Insert the order ID, if applicable
    orderValue: value || 0,
    quantity: quantity || 0,
    event: "user_purchase_flying_high",
    email,
    new_customer: newCustomer,
  });
  emitFacebookTrack("UserPurchaseFlyingHigh", {
    value: value || 0,
    quantity: quantity || 0,
    order_id: orderId,
    currency,
  });
};

export const premiumPurchase = ({
                                  orderId,
                                  value,
                                  currency,
                                  email,
                                  newCustomer,
                                }: {
  orderId?: any;
  value?: number;
  currency?: string;
  email: string;
  newCustomer: boolean;
}) => {
  emitGoogleTrack({
    orderId: orderId || "", // Insert the order ID, if applicable
    orderValue: value || 0,
    event: "voip_enterprise",
    email,
    new_customer: newCustomer,
  });
  emitFacebookTrack("VoIPEnterprise", {
    value: value || 0,
    order_id: orderId,
    currency,
  });
  emitLinkedinTrack("1441033");
};

export const premiumUserPurchase = ({
                                      orderId,
                                      value,
                                      quantity,
                                      currency,
                                      email,
                                      newCustomer,
                                    }: {
  orderId?: any;
  value?: number;
  quantity?: number;
  currency?: string;
  email: string;
  newCustomer: boolean;
}) => {
  emitGoogleTrack({
    orderId: orderId || "", // Insert the order ID, if applicable
    orderValue: value || 0,
    quantity: quantity || 0,
    event: "user_purchase_enterprise",
    email: email,
    new_customer: newCustomer,
  });
  emitFacebookTrack("UserPurchaseEnterprise", {
    value: value || 0,
    quantity: quantity || 0,
    currency,
    order_id: orderId,
  });
};

export const numberPurchase = ({
                                 orderId,
                                 value,
                                 quantity,
                                 event,
                                 email,
                                 newCustomer,
                               }: {
  orderId?: any;
  value?: number;
  quantity?: number;
  event: string;
  email: string;
  newCustomer: boolean;
}) => {
  emitGoogleTrack({
    orderId: orderId || "", // Insert the order ID, if applicable
    orderValue: value || 0,
    quantity: quantity || 0,
    event: event,
    email,
    new_customer: newCustomer,
  });
};

export const addOnProducts = ({
                                orderId,
                                value,
                                email,
                                newCustomer,
                              }: {
  orderId?: any;
  value?: number;
  email: string;
  newCustomer: boolean;
}) => {
  emitGoogleTrack({
    orderId: orderId || "", // Insert the order ID, if applicable
    orderValue: value || 0,
    event: "addon_purchase",
    email,
    new_customer: newCustomer,
  });
};

export const checkoutSuccess = ({
                                  value,
                                  currency,
                                  transactionId,
                                  tax,
                                  items,
                                }: {
  value: number;
  currency: string;
  transactionId: string | number;
  tax: number;
  items: {
    item_id: string;
    item_name: string;
    item_category: number;
    price: number;
    quantity: number;
  }[];
}) => {
  emitGoogleTrack({
    event: "purchase",
    ecommerce: {
      transaction_id: transactionId,
      value,
      tax,
      currency,
      items,
    },
  });
  emitFacebookTrack("Purchase", {
    value,
    currency,
    order_id: transactionId,
  });
};

export const planPurchase = ({
                               value,
                               email,
                               orderId,
                               newCustomer,
                             }: {
  value: number;
  email: string;
  orderId: string | number;
  newCustomer: boolean;
}) => {
  emitGoogleTrack({
    event: "plan_purchase",
    orderId: orderId,
    orderValue: value,
    email,
    new_customer: newCustomer,
  });
};

export const resellerPackage = ({
                                  orderId,
                                  value,
                                  email,
                                  newCustomer,
                                }: {
  orderId?: any;
  value?: number;
  email: string;
  newCustomer: boolean;
}) => {
  emitGoogleTrack({
    orderId: orderId || "", // Insert the order ID, if applicable
    orderValue: value || 0,
    event: "reseller",
    email,
    new_customer: newCustomer,
  });
};

export const domainPurchase = ({
                                 orderId,
                                 value,
                                 currency,
                                 email,
                                 newCustomer,
                               }: {
  orderId?: any;
  value?: number;
  currency?: string;
  email: string;
  newCustomer: boolean;
}) => {
  emitGoogleTrack({
    orderId: orderId || "", // Insert the order ID, if applicable
    orderValue: value || 0,
    event: "domain_registration",
    email,
    new_customer: newCustomer,
  });
  emitFacebookTrack("DomainReg", {
    value,
    order_id: orderId,
    currency,
  });
};

export const domainTransfer = ({
                                 orderId,
                                 value,
                                 currency,
                                 email,
                                 newCustomer,
                               }: {
  orderId?: any;
  value?: number;
  currency?: string;
  email: string;
  newCustomer: boolean;
}) => {
  emitGoogleTrack({
    orderId: orderId || "", // Insert the order ID, if applicable
    orderValue: value || 0,
    event: "domain_transfer",
    email,
    new_customer: newCustomer,
  });
  emitFacebookTrack("DomainTransfer", {
    value,
    order_id: orderId,
    currency,
  });
};

export const addToCart = () => {
  emitFacebookTrack("AddToCart");
};

export const initiateCheckout = () => {
  emitFacebookTrack("InitiateCheckout");
};

export const beginCheckout = () => {
  emitGoogleTrack({
    event: "begin_checkout",
  });
};

export const addPaymentInfo = () => {
  emitGoogleTrack({
    event: "add_payment_info",
  });
};
